<template>
  <div>
    <!-- <v-btn color="primary" @click="exportBot">Export Bot</v-btn> -->
    <!-- <v-btn color="primary" @click="importDialog = true" style="margin-top: 0px;">Import Bot</v-btn> -->
    <!--    export dialog-->
    <v-dialog width="800" v-model="exportDialog">
      <v-card>
        <v-card-title class="headline" primary-title> Export Bot </v-card-title>
        <v-card-text class="text-center">
          <v-chip
            v-clipboard:copy="exportUrl"
            v-clipboard:success="onCopy"
            class="cursor-pointer"
            >{{ exportUrl }}
            <v-icon small class="pl-2">file_copy</v-icon></v-chip
          >
          <p class="mt-3">
            Use this url to migrate Bot data to another account
          </p>
        </v-card-text>
        <v-card-actions class="text-center d-block">
          <v-btn color="primary" @click="exportDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    import dialog-->
    <v-dialog v-model="importDialog" width="600" @submit="importBot">
      <v-card>
        <v-card-title class="headline" primary-title> Import Bot </v-card-title>
        <v-form ref="importForm">
          <v-card-text>
            <label for="" class="mt-2">JSON URL</label>
            <v-text-field
              outline
              :rules="[(v) => !!v || 'Url is required', isValidUrl]"
              v-model="importData.url"
            />
            <label for="" v-model="importData.bot_name" class="mt-2"
              >Bot name</label
            >
            <v-text-field
              outline
              :rules="[(v) => !!v || 'Name is required']"
              v-model="importData.bot_name"
              v-if="importData.new_bot"
            />

            <v-layout row wrap>
              <v-flex xs6>
                <label for="">Copy To New Bot?</label>
                <v-radio-group v-model="importData.new_bot" row>
                  <v-radio color="primary" :value="true" label="Yes"
                    >Yes</v-radio
                  >
                  <v-radio color="primary" :value="false" label="No"
                    >No</v-radio
                  >
                </v-radio-group>
              </v-flex>
              <v-flex xs6>
                <label for="">Copy Menus?</label>
                <v-radio-group v-model="importData.menus" row>
                  <v-radio color="primary" :value="true" label="Yes"
                    >Yes</v-radio
                  >
                  <v-radio color="primary" :value="false" label="No"
                    >No</v-radio
                  >
                </v-radio-group>
              </v-flex>
              <v-flex xs6>
                <label for="">Copy Forms?</label>
                <v-radio-group v-model="importData.forms" row>
                  <v-radio color="primary" :value="true" label="Yes"
                    >Yes</v-radio
                  >
                  <v-radio color="primary" :value="false" label="No"
                    >No</v-radio
                  >
                </v-radio-group>
              </v-flex>
              <v-flex xs6>
                <label for="">Copy FAQs?</label>
                <v-radio-group v-model="importData.faqs" row>
                  <v-radio color="primary" :value="true" label="Yes"
                    >Yes</v-radio
                  >
                  <v-radio color="primary" :value="false" label="No"
                    >No</v-radio
                  >
                </v-radio-group>
              </v-flex>
              <v-flex xs6>
                <label for="">Copy Bad Words</label>
                <v-radio-group v-model="importData.bad_words" row>
                  <v-radio color="primary" :value="true" label="Yes"
                    >Yes</v-radio
                  >
                  <v-radio color="primary" :value="false" label="No"
                    >No</v-radio
                  >
                </v-radio-group>
              </v-flex>
            </v-layout>

            <p class="red--text" v-if="!importData.new_bot">
              This option will delete all current bot data
            </p>
          </v-card-text>
          <v-card-actions class="d-block text-xs-right">
            <v-btn color="primary" @click="importBot">Import</v-btn>
            <v-btn color="" @click="importDialog = false" outline>Close</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/utils/common";
export default {
  name: "botMigration",
  props: {
    botImportDialog: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    source: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      exportUrl: "",
      importData: {
        bot_id: "",
        bot_name: "",
        new_bot: true,
        forms: true,
        menus: true,
        faqs: true,
        bad_words: true,
        url: "",
      },
      exportDialog: false,
      importDialog: false,
      common,
    };
  },
  methods: {
    isValidUrl(url) {
      return (
        new RegExp(
          /https?:\/\/(www\.)?[-a-zA-Z0-9@:%.\+~#=]{1,256}(\.)?[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
        ).test(url) || "URL Not Valid"
      );
    },
    async exportBot() {
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_bot.get(
        `/bot/${this.$store.state.bot.botId}/export`
      );

      this.exportUrl = response.data.url;
      this.exportDialog = true;
      this.$store.dispatch("setLoader", false);
    },
    async importBot() {
      if (this.$refs.importForm.validate()) {
        this.$store.dispatch("setLoader", true);
        this.importData.bot_id = this.$store.state.bot.botId;
        if (!this.importData.new_bot) {
          delete this.importData.bot_name;
        }
        await this.$http_bot({
          url: "/bot/import",
          method: "post",
          data: this.importData,
          timeout: 900000,
        });

        this.$store.dispatch("setLoader", false);
        this.importDialog = false;
        this.$store.dispatch("setSnackbar", {
          text: "Bot data has been imported successfully",
          color: "primary",
          status: true,
        });
        if (this.source === "home") {
          this.$emit("reloadBots");
        } else {
          this.$router.push("/");
        }
      }
    },
    onCopy() {
      this.$store.dispatch("setSnackbar", {
        text: "Text copied to your clipboard",
        color: "primary",
        status: true,
      });
    },
  },
  watch: {
    botImportDialog(val) {
      this.importDialog = val;
    },
    importDialog() {
      if (this.importDialog === false) {
        this.$emit("closeDialog");
      }
    },
  },
};
</script>

<style scoped></style>
